import constants from "../../core/constants";

import approveReimbursementDialogTemplate from "./approveReimbursementDialog/approveReimbursementDialog.html";
import approveReimbursementDialogTemplateController from "./approveReimbursementDialog/approveReimbursementDialog.controller";

import rejectReimbursementDialogTemplate from "./rejectReimbursementDialog/rejectReimbursementDialog.html";
import rejectReimbursementDialogController from "./rejectReimbursementDialog/rejectReimbursementDialog.controller";

import reviewReimbursementDialogTemplate from "./reviewReimbursementDialog/reviewReimbursementDialog.html";
import reviewReimbursementDialogController from "./reviewReimbursementDialog/reviewReimbursementDialog.controller";

class Controller {
  constructor(
    $stateParams,
    $mdDialog,
    Events,
    Sections,
    FineReimbursementTransforms,
    FineReimbursement
  ) {
    "ngInject";

    this.$stateParams = $stateParams;
    this.$mdDialog = $mdDialog;
    this.sections = Sections.plansSections;
    this.Events = Events;
    this.FineReimbursementTransforms = FineReimbursementTransforms;
    this.FineReimbursement = FineReimbursement;

    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;
    this.successNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
  }

  $onInit() {
    this.FineReimbursement.get(
      this.$stateParams.id
    ).$promise.then(this.hydratePage.bind(this), (response) =>
      this.Events.emit(this.errorNotificationEvent, response.data)
    );
  }

  $onDestroy() {
    this.$mdDialog.cancel();
  }

  hydratePage(response) {
    this.fineReimbursement = this.FineReimbursementTransforms.justify(response);
  }

  approveReimbursement() {
    this.$mdDialog
      .show({
        controller: approveReimbursementDialogTemplateController,
        controllerAs: "$ctrl",
        template: approveReimbursementDialogTemplate,
        clickOutsideToClose: true,
        locals: {
          fineReimbursement: this.fineReimbursement,
        },
      })
      .then(
        ({ fine_no: fineNo, ride_id: rideId, amount, bus_no: busNo, note }) => {
          amount *= constants.currencyBy;

          this.FineReimbursement.postDecision(
            this.$stateParams.id,
            "initial_approve",
            { fine_no: fineNo, ride_id: rideId, amount, bus_no: busNo, note }
          ).$promise.then(this.hydratePage.bind(this), (response) =>
            this.Events.emit(this.errorNotificationEvent, response.data)
          );
        }
      );
  }

  rejectReimbursement() {
    this.$mdDialog
      .show({
        controller: rejectReimbursementDialogController,
        controllerAs: "$ctrl",
        template: rejectReimbursementDialogTemplate,
        clickOutsideToClose: true,
      })
      .then((model) => {
        this.FineReimbursement.postDecision(
          this.$stateParams.id,
          "reject",
          model
        ).$promise.then(this.hydratePage.bind(this), (response) =>
          this.Events.emit(this.errorNotificationEvent, response.data)
        );
      });
  }

  reviewReimbursement() {
    this.$mdDialog
      .show({
        controller: reviewReimbursementDialogController,
        controllerAs: "$ctrl",
        template: reviewReimbursementDialogTemplate,
        clickOutsideToClose: true,
        locals: {
          fineReimbursement: this.fineReimbursement,
        },
      })
      .then((action) => {
        switch (action) {
          case "approve":
            this.reviewApprove();
            break;

          case "reject":
            this.rejectReimbursement();
            break;

          default:
            throw new Error(
              `${action} is not an acceptable fine reimbursement review action`
            );
        }
      });
  }

  reviewApprove() {
    this.FineReimbursement.postDecision(
      this.$stateParams.id,
      "final_approve"
    ).$promise.then(this.hydratePage.bind(this), (response) =>
      this.Events.emit(this.errorNotificationEvent, response.data)
    );
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/fineReimbursement/fineReimbursement.controller.js